import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { MsalService } from '../services/msal.service';
import { SessionService } from '../services/session.service';

export const authGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthService);
  const msal = inject(MsalService);
  const session = inject(SessionService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return true;
  }

  session.setRedirectPath(state.url);

  try {
    await msal.initialize();
    const account = msal.getAllAccounts()[0];
    if (account && !auth.principal()) {
      auth.setPrincipal({
        name: account.name,
        username: account.username,
        localAccountId: account.localAccountId,
      });
    }

    if (account) {
      const token = await msal.getAccessToken();
      if (token?.accessToken) {
        auth.setAccessToken(token.accessToken, token.expiresIn);
        return true;
      }
    }
  } catch (error) {
    console.warn('Silent authentication check failed:', error);
  }

  return router.createUrlTree(['/login']);
};
